import React from 'react';
import PropTypes from 'prop-types';

import { Link, Text, Box } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';

import { stringInputSpec, titleInput } from '../../lib/editing-configs';

import styles from './story-block.module.less';

const StoryBlockStory = ({ title, linkUrl, previewImg }) => (
  <li className={styles['story-block-story__cont']}>
    {previewImg ? (
      <Link href={linkUrl} target="_blank">
        <Image
          className={styles['story-block-image__cont']}
          src={previewImg}
          objectFit="cover"
          objectPosition="center"
          alt={title}
        >
          <Box className={styles['story-block-image__overlay']} />
        </Image>
      </Link>
    ) : null}
    <Box className={styles['story-block-body__cont']}>
      <Link href={linkUrl} color="neutral-darkest" target="_blank">
        <Text>{title}</Text>
      </Link>
    </Box>
  </li>
);

StoryBlockStory.displayName = 'StoryBlockStory';

StoryBlockStory.propTypes = {
  title: PropTypes.string,
  linkUrl: PropTypes.string,
  previewImg: PropTypes.string,
};

StoryBlockStory.defaultProps = {
  title: '',
  linkUrl: '',
  previewImg: '',
};

StoryBlockStory.getEditingConfig = () => [
  titleInput,
  stringInputSpec('linkUrl', 'URL of story'),
  stringInputSpec('previewImg', 'Preview image URL'),
];

export default StoryBlockStory;
